module.exports = __webpack_public_path__ + "static/media/nike_store.855aee58.mp4";